import { render, staticRenderFns } from "./YouAndMeTextLoader.vue?vue&type=template&id=8fe1170c&scoped=true&"
import script from "./YouAndMeTextLoader.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextLoader.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeTextLoader.vue?vue&type=style&index=0&id=8fe1170c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe1170c",
  null
  
)

export default component.exports